import React from "react";

/**
 * Column definitions for the Devices Management module data tables
 */

export const devicesManagementColumnDefinitions = {
  projects: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Display Name",
      selector: (row) => row.recDisplayName,
      sortable: true,
      width: "200px",
    },
    {
      name: "Project Name",
      selector: (row) => row.projName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Device ID",
      selector: (row) => row.deviceId,
      sortable: true,
      width: "280px",
      cell: (row) => (
        <span style={{ fontSize: "0.85rem", fontFamily: "monospace" }}>
          {row.deviceId}
        </span>
      ),
    },
    {
      name: "Org ID",
      selector: (row) => row.orgId,
      sortable: true,
      width: "180px",
    },
    {
      name: "Assigned At",
      selector: (row) => row.assignedAt,
      sortable: true,
      width: "130px",
      cell: (row) => row.assignedAt ? new Date(row.assignedAt).toLocaleDateString() : "-",
    },
    {
      name: "Assigned By",
      selector: (row) => row.assignedBy,
      sortable: true,
      width: "120px",
      cell: (row) => row.assignedBy || "-",
    },
    {
      name: "Last Update",
      selector: (row) => row.lastUpdate,
      sortable: true,
      width: "150px",
      cell: (row) => row.lastUpdate ? new Date(row.lastUpdate).toLocaleString() : "-",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "130px",
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
  ],
  points: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Point ID",
      selector: (row) => row.pointId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Display Name",
      selector: (row) => row.pointDisplayName,
      sortable: true,
      width: "250px",
    },
    {
      name: "Project ID",
      selector: (row) => row.projId,
      sortable: true,
      width: "150px",
    },
    {
      name: "Kind",
      selector: (row) => row.kind,
      sortable: true,
      width: "100px",
    },
    {
      name: "Point Type",
      selector: (row) => row.pointTypeEnum,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <span style={{ fontFamily: "monospace", fontSize: "0.85rem" }}>
          {row.pointTypeEnum || "-"}
        </span>
      ),
    },
    {
      name: "Current Value",
      selector: (row) => row.curVal,
      sortable: false,
      width: "150px",
      cell: (row) => {
        if (row.curVal === null) return "-";
        if (typeof row.curVal === 'object' && row.curVal._kind === 'number') {
          return `${row.curVal.val} ${row.curVal.unit || ""}`;
        }
        return row.curVal;
      },
    },
    {
      name: "Status",
      selector: (row) => row.curStatus,
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit",
      selector: (row) => row.unit,
      sortable: false,
      width: "80px",
      cell: (row) => row.unit || "-",
    },
    {
      name: "Writable",
      selector: (row) => row.writable,
      sortable: true,
      width: "100px",
      cell: (row) => row.writable ? "Yes" : "No",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "130px",
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
  ],
  sites: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
    },
    {
      name: "Partner UUID",
      selector: (row) => row.partnerUuid,
      sortable: true,
      width: "280px",
    },
    {
      name: "Assigned By",
      selector: (row) => row.assignedBy,
      sortable: true,
      width: "150px",
      cell: (row) => row.assignedBy || "-",
    },
    {
      name: "Assigned At",
      selector: (row) => row.assignedAt,
      sortable: true,
      width: "180px",
      cell: (row) => row.assignedAt ? new Date(row.assignedAt).toLocaleString() : "-",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.createdAt).toLocaleString(),
    },
    {
      name: "Updated At",
      selector: (row) => row.updatedAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.updatedAt).toLocaleString(),
    },
  ],
  deviceTypes: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      width: "300px",
      cell: (row) => row.description || "-",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.createdAt).toLocaleString(),
    },
    {
      name: "Updated At",
      selector: (row) => row.updatedAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.updatedAt).toLocaleString(),
    },
  ],
  roomTypes: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: false,
      width: "280px",
      cell: (row) => row.description || "-",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.createdAt).toLocaleString(),
    },
    {
      name: "Updated At",
      selector: (row) => row.updatedAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.updatedAt).toLocaleString(),
    },
  ],
  pointTypes: [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "180px",
    },
    {
      name: "Enum Value",
      selector: (row) => row.enumValue,
      sortable: true,
      width: "180px",
      cell: (row) => (
          <span style={{ fontFamily: "monospace", fontSize: "0.85rem" }}>
            {row.enumValue || "-"}
          </span>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: false,
      width: "280px",
      cell: (row) => row.description || "-",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.createdAt).toLocaleString(),
    },
    {
      name: "Updated At",
      selector: (row) => row.updatedAt,
      sortable: true,
      width: "180px",
      cell: (row) => new Date(row.updatedAt).toLocaleString(),
    },
  ],
};
